<template>
  <div>
    <div class="demo-swiper-panel">
      <div class="demo-title">默认情况</div>
      <div class="bx-swiper bx-swiper-image">
        <div class="bx-swiper-scroller">
          <a class="bx-swiper-slide">
            <img src="http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner" class="img-responsive">
          </a>
          <a class="bx-swiper-slide">
            <img src="http://img.winbaoxian.com/learning/banner/2017/02/28/214011694.png@!banner" class="img-responsive">
          </a>
          <a class="bx-swiper-slide">
            <img src="http://img.winbaoxian.com/learning/banner/2016/12/30/094713105.png@!banner" class="img-responsive">
          </a>
          <a class="bx-swiper-slide">
            <img src="http://img.winbaoxian.com/learning/banner/2016/03/16/145053945.jpeg@!banner" class="img-responsive">
          </a>
        </div>
      </div>
    </div>
    <div class="demo-swiper-panel">
      <div class="demo-title">高度为宽度的30%</div>
      <div class="bx-swiper bx-swiper-page">
        <div class="bx-swiper-scroller">
          <div class="bx-swiper-slide">
            <div style="height: 160px;background-color: red;font-size: 60px;text-align: center">1</div>
          </div>
          <div class="bx-swiper-slide">
            <div style="height: 170px;background-color: green;font-size: 60px;text-align: center">2</div>
          </div>
          <div class="bx-swiper-slide">
            <div style="height: 150px;background-color: plum;font-size: 60px;text-align: center">3</div>
          </div>
          <div class="bx-swiper-slide">
            <div style="height: 150px;background-color: tomato;font-size: 60px;text-align: center">4</div>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-swiper-panel">
      <div class="demo-title">取消自动播放</div>
      <div class="bx-swiper bx-swiper-color">
        <div class="bx-swiper-scroller">
          <a class="bx-swiper-slide">
            <img src="http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner" class="img-responsive">
          </a>
          <div class="bx-swiper-slide">
            <div style="height: 160px;background-color: red;font-size: 60px;text-align: center">1</div>
          </div>
          <div class="bx-swiper-slide">
            <div style="height: 170px;background-color: green;font-size: 60px;text-align: center">2</div>
          </div>
          <div class="bx-swiper-slide">
            <div style="height: 150px;background-color: plum;font-size: 60px;text-align: center">3</div>
          </div>
        </div>
      </div>
    </div>
    <div class="demo-swiper-panel">
      <div class="demo-title">单项默认情况</div>
      <div class="bx-swiper bx-swiper-single">
      <div class="bx-swiper-scroller">
        <a class="bx-swiper-slide">
          <img src="http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner" class="img-responsive">
        </a>
      </div>
    </div>
    </div>
    <div class="demo-swiper-panel">
      <div class="demo-title">自定义分页器/指示器样式</div>
      <div class="bx-swiper bx-swiper-custom">
      <div class="bx-swiper-scroller">
        <div class="bx-swiper-slide bx-swiper-slide--active">
          <div style="height: 160px;background-color: red;font-size: 60px;text-align: center">1</div>
        </div>
        <div class="bx-swiper-slide">
          <div style="height: 170px;background-color: green;font-size: 60px;text-align: center">2</div>
        </div>
        <div class="bx-swiper-slide">
          <div style="height: 150px;background-color: plum;font-size: 60px;text-align: center">3</div>
        </div>
        <div class="bx-swiper-slide">
          <div style="height: 150px;background-color: tomato;font-size: 60px;text-align: center">4</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import Swiper from '@packages/components/swiper/swiper'
  export default {
    mounted: function () {
      this.$nextTick(function () {
        Swiper.create('.bx-swiper-color', {
          autoplay: false
        });
        Swiper.create('.bx-swiper-page', {
          height: '30%',
          onInit: function () {
            console.log('onInit');
          },
          onTouchStart: function () {
            console.log('onTouchStart');
          },
          onTouchMove: function () {
            console.log('onTouchMove');
          },
          onTouchEnd: function () {
            console.log('onTouchEnd');
          },
          onSlide: function () {
            console.log('onSlide');
          },
          onSlidePrev: function () {
            console.log('onSlidePrev');
          },
          onSlideNext: function () {
            console.log('onSlideNext');
          },
          onTransitionEnd: function () {
            console.log('onTransitionEnd');
          }
        });
        Swiper.create('.bx-swiper-image');
        Swiper.create('.bx-swiper-single');
        Swiper.create('.bx-swiper-custom', {
          height: '30%',
          paginationClass: 'ui-swiper-paginations'
        });
      });
    }
  }
</script>
<style>
  .bx-swiper .ui-swiper-paginations .bx-swiper-pagination {
    border-radius: 0;
    background-color: #fff4c2;
  }
  .demo-swiper-panel {
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Swiper.vue